"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBox = exports.CSS = void 0;
var mithril_1 = require("../../mithril");
var icon_1 = require("../icon");
var icons_1 = require("../icon/icons");
var theme_1 = require("../theme");
exports.CSS = {
    container: 'c-CheckBox',
    isSelected: 'c-CheckBox--selected',
    isIndeterminate: 'c-CheckBox--indeterminate',
    isDisabled: 'c-CheckBox--disabled'
};
(0, theme_1.addStyles)((_a = {},
    _a[exports.CSS.container] = {
        userSelect: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a[exports.CSS.isSelected] = {
        color: theme_1.DefaultTheme.font.color.link
    },
    _a[exports.CSS.isIndeterminate] = {
        color: theme_1.DefaultTheme.font.color.link
    },
    _a[exports.CSS.isDisabled] = {
        color: theme_1.DefaultTheme.font.color.disabled
    },
    _a));
exports.CheckBox = {
    view: function (state) {
        var isSelected = state.isSelected() === true;
        var className = exports.CSS.container;
        var materialIcon = icons_1.MaterialIcon.CHECK_BOX;
        if (isSelected) {
            className += ' ' + exports.CSS.isSelected;
            materialIcon = icons_1.MaterialIcon.CHECK_BOX_SELECTED;
        }
        else if (state.isIndeterminate != null && state.isIndeterminate()) {
            className += ' ' + exports.CSS.isIndeterminate;
            materialIcon = icons_1.MaterialIcon.CHECK_BOX_INDETERMINATE;
        }
        if (state.isDisabled) {
            className += ' ' + exports.CSS.isDisabled;
        }
        return (0, mithril_1.m)('div', {
            className: className,
            onclick: !state.isDisabled ? function (ev) {
                ev.stopPropagation();
                state.setSelected(!isSelected);
            } : null
        }, icon_1.Icon.view(materialIcon));
    }
};
//# sourceMappingURL=input.checkbox.js.map